import React from 'react';
import styled from '@emotion/styled';

import { FieldRadioButtonLayout } from 'components/shared/Fields/FieldRadioButton/FieldRadioButton';
import { MEDIA_QUERY, Theme } from 'theme';
import { useTypedIntl } from '../../locale/messages';
import { ChartType } from '../StatisticsPage';

const Container = styled.div<{ theme?: Theme }>`
  width: 260px;

  label {
    font-size: 11px;
  }

  @media ${MEDIA_QUERY.MAX_MD} {
    width: 240px;
  }
`;

interface Props {
  selected: ChartType;
  onChartTypeChange: (type: ChartType) => void;
}

export const ChangeTabs = ({ selected, onChartTypeChange }: Props): React.ReactElement => {
  const intl = useTypedIntl();
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChartTypeChange(e.target.value as ChartType);
  };
  const options = [
    {
      value: 'view',
      label: intl.formatMessage({
        id: 'Statistics.Chart.Mode.Views',
      }),
    },
    {
      value: 'search',
      label: intl.formatMessage({
        id: 'Statistics.Chart.Mode.Searches',
      }),
    },
    {
      value: 'flyers',
      label: intl.formatMessage({
        id: 'Statistics.Chart.Mode.Flyers',
      }),
    },
  ];

  return (
    <Container>
      <FieldRadioButtonLayout
        value={selected}
        name="statisticChartMode"
        options={options}
        onChange={handleChange}
      />
    </Container>
  );
};
